/**
 * The ServiceGateway API
 * The ServiceGateway provides APIs to interact with the Gintel Easy Business Communications Suite (EBCS)
 *
 * OpenAPI spec version: 1.14.31-SNAPSHOT
 * Contact: frank.paaske@gintel.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */


export interface CustomerNotification { 
    url?: string;
    updateAvailable?: boolean;
    updateForced?: boolean;
    notificationText?: string;
}
